// assets/js/ui/nav.js
import { onReady } from "../base/common.js";

onReady(() => {
    const bodyEl = document.querySelector(".l-body") || document.body;
    const toggle = document.querySelector(".c-gnav__toggle");
    const nav = document.getElementById("globalnav");
    const headerInner =
        document.querySelector(".l-header__inner") ||
        document.querySelector(".l-header");

    if (!toggle || !nav || !headerInner) return;

    let lastFocused = null;
    let lockedScrollY = 0;

    // ルートに状態クラスを付与（他JSへもイベント通知）
    const setNavState = (open) => {
        document.documentElement.classList.toggle("is-nav-open", open);
        document.dispatchEvent(new CustomEvent("nav:toggle", { detail: { open } }));
    };

    const lockScroll = () => {
        lockedScrollY = window.scrollY || window.pageYOffset || 0;
        // iOS対策：ボディをfixed化
        bodyEl.style.position = "fixed";
        bodyEl.style.top = `-${lockedScrollY}px`;
        bodyEl.style.left = "0";
        bodyEl.style.right = "0";
        bodyEl.style.width = "100%";
        document.documentElement.classList.add("u-noscr");
    };

    const unlockScroll = () => {
        bodyEl.style.position = "";
        bodyEl.style.top = "";
        bodyEl.style.left = "";
        bodyEl.style.right = "";
        bodyEl.style.width = "";
        document.documentElement.classList.remove("u-noscr");
        window.scrollTo(0, lockedScrollY);
    };

    const close = () => {
        if (!nav.classList.contains("is-open")) return;
        toggle.classList.remove("is-open");
        nav.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
        setNavState(false);
        unlockScroll();
        if (lastFocused && typeof lastFocused.focus === "function") {
            lastFocused.focus({ preventScroll: true });
        }
    };

    const open = () => {
        lastFocused = document.activeElement;
        toggle.classList.add("is-open");
        nav.classList.add("is-open");
        toggle.setAttribute("aria-expanded", "true");
        setNavState(true);
        lockScroll();
        const first = nav.querySelector("a, button, [tabindex]:not([tabindex='-1'])");
        if (first) first.focus({ preventScroll: true });
    };

    // 開閉
    toggle.addEventListener("click", (e) => {
        e.stopPropagation();
        const expanded = toggle.getAttribute("aria-expanded") === "true";
        expanded ? close() : open();
    });

    // 外側クリックで閉じる
    document.addEventListener("click", (e) => {
        if (!nav.classList.contains("is-open")) return;
        if (!e.target.closest(".c-gnav, .c-gnav__toggle")) close();
    });

    // Escで閉じる
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && nav.classList.contains("is-open")) close();
    });

    // ナビのリンク選択で閉じる
    nav.addEventListener("click", (e) => {
        if (!nav.classList.contains("is-open")) return;
        const a = e.target.closest("a[href]");
        if (a) close();
    });

    // フォーカストラップ（Tabでドロワー外に逃げないように）
    nav.addEventListener("keydown", (e) => {
        if (e.key !== "Tab" || !nav.classList.contains("is-open")) return;
        const focusables = nav.querySelectorAll(
            'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];

        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    });

    // オーバーレイ→インライン表示に戻ったら自動クローズ
    const ro = new ResizeObserver(() => {
        const isOverlay = window.getComputedStyle(nav).position === "fixed";
        if (!isOverlay && nav.classList.contains("is-open")) close();
    });
    ro.observe(headerInner);

    // 1vh対策
    const setVH = () =>
        document.documentElement.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
    setVH();
    window.addEventListener("resize", setVH, { passive: true });
    window.addEventListener("pageshow", (e) => {
        if (e.persisted) setVH();
    });
    window.addEventListener("pagehide", () => ro.disconnect());

    // PC幅に戻ったら強制クローズ＆状態クラス除去
    const mqlPc = window.matchMedia("(min-width: 1025px)");
    const mqHandler = (e) => {
        if (e.matches && nav.classList.contains("is-open")) {
            toggle.setAttribute("aria-expanded", "false");
            nav.classList.remove("is-open");
            document.documentElement.classList.remove("is-nav-open");
            unlockScroll();
            toggle.classList.remove("is-open");
        }
    };
    // Safari旧API互換
    mqlPc.addEventListener ? mqlPc.addEventListener("change", mqHandler) : mqlPc.addListener(mqHandler);
});
